import { DatePicker } from 'antd';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)<{ minWidthInput?: string }>`
  border-radius: 6px !important;
  height: 44px;
  .ant-picker-input > input {
    ::placeholder {
      font-style: italic;
    }
  }
  .ant-picker-suffix {
    height: 16px;
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-picker-input:hover .ant-picker-clear {
    height: 16px;
    width: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ant-picker-input > input {
    min-width: ${props => props.minWidthInput ?? '170px'};
  }
`;
export const DatePickerWrapper = styled.div`
  .custom-date-popup {
    .ant-picker-panel-container {
      border-radius: 12px;
    }
    /* Header (tháng/năm) */
    .ant-picker-header {
    }
    .ant-picker-date-panel {
      width: auto;
    }
    .ant-picker-date-panel .ant-picker-content {
      table-layout: auto;
    }
    .ant-picker-cell-disabled::before {
      height: 100%;
    }
    .ant-picker-cell-disabled .ant-picker-cell-inner {
    }
    /* Ô ngày */
    .ant-picker-cell-inner {
      width: 35px;
      height: 35px;
      margin: 2px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      transition: background-color 0.25s ease, color 0.25s ease,
        transform 0.15s ease;
    }
    /* Hover ngày */
    .ant-picker-cell:not(.ant-picker-cell-disabled):not(.ant-picker-cell-selected)
      .ant-picker-cell-inner:hover {
      background: var(--color-10) !important;
      color: #fff;
      transform: scale(1.05);
    }
    /* Ngày được chọn */
    .ant-picker-cell-selected .ant-picker-cell-inner {
      background: var(--color-10);
      color: #fff;
    }
    /* Today */
    .ant-picker-cell-today .ant-picker-cell-inner::before {
      border-radius: 50%;
    }
    .ant-picker-cell-today:not(.ant-picker-cell-disabled)
      .ant-picker-cell-inner::before {
      border-color: var(--color-10);
    }
    .ant-picker-footer .ant-picker-today-btn {
      color: var(--color-10);
      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
export default StyledDatePicker;
